import React from 'react'
import { CSSProperties } from 'styled-components'
import { AppLogoWrap } from './styles'
import AuthButtonLists from '../../organisms/Header/AuthHeaderMenu/AuthButtonLists'
import { useToken } from '../../hooks'
import { COLORS } from '../../constants'

interface IProps {
	width?: string | number
	height?: number
	onPress?: () => void
	style?: CSSProperties
}

const AppLogo = ({ width, height, onPress, style }: IProps) => {
	const { data: token, mutate } = useToken()
	return (
		<AppLogoWrap>
			<div onClick={onPress}>ADMIN DASHBOARD</div>
			{token && (
				<AuthButtonLists
					title={'logout'}
					action={() => {
						mutate(null)
						setTimeout(() => window.location.reload(), 100)
					}}
					style={{
						background: COLORS.secondary,
						width: '100%',
						color: '#fff',
					}}
				/>
			)}
		</AppLogoWrap>
	)
}

export default React.memo(AppLogo)
